import { Box } from "@mui/material";
import PropTypes from "prop-types";

import DoctorSelector from "./DoctorSelector";
import RoleTabs from "./RoleTabs";

interface DashboardHeaderProps {
  onRoleChange?: (role: string) => void;
  doctorName?: string;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  onRoleChange,
  doctorName = "Dr. Johnson",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "4px",
      }}
    >
      {/* Left side - Role Tabs */}
      <Box sx={{ flex: "0 0 33.33%" }}>
        <RoleTabs onRoleChange={onRoleChange} />
      </Box>

      {/* Right side - Doctor Selector */}
      <Box>
        <DoctorSelector doctorName={doctorName} />
      </Box>
    </Box>
  );
};

DashboardHeader.propTypes = {
  onRoleChange: PropTypes.func,
  doctorName: PropTypes.string,
};

export default DashboardHeader;
